module.exports = __webpack_public_path__ + "static/img/group3.b95d4744.png";